import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { useRouter } from 'vue-router/composables';
import SButton from '@/components/SButton/SButton.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/Confirmation-Dialog.vue';
import i18n from '@/i18n';
import type { Location } from 'vue-router';
import { VSelect } from 'vuetify/lib';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveSearchSelector',
  props: {
  items: null,
  value: null
},
  emits: ["delete", "input"],
  setup(__props, { emit }) {

const props = __props;
const router = useRouter();

const { value: selectedSearch } = __MACROS_useVModel(["value", undefined, "input"]);





const confirmationDialogRef = _ref<ConfirmationDialog | null>(null);
const select = _ref<InstanceType<typeof VSelect> | null>(null);

  const itemClickHandler = (item: { value: string, text: string, query: Location['query'] }) => {
  confirmationDialogRef.value!
    .setTitle(i18n.tc('save_search.delete_modal_title', 1, { count: 1 }) as string)
    .setBody(i18n.tc('save_search.delete_modal_description', 1, { count: 1 }) as string)
    .waitForUserAction()
    .then(() => {
      emit('delete', item.value);
    })
    .catch(() => { });
};

const handleInput = (value: string) => {
  if (value) {
    router.push({ query: props.items.find((item) => item.value === value)?.query });
  }
};

const handleClear = () => {
  router.push({ query: {} });
};

onMounted(() => {
  if (select.value?.$refs.input instanceof HTMLElement) {
    select.value.$refs.input.focus();
  }
});

return { __sfc: true,router, selectedSearch, props, emit, confirmationDialogRef, select, itemClickHandler, handleInput, handleClear, _ref, __MACROS_useVModel, useRouter, SButton, ConfirmationDialog, i18n, VSelect, onMounted }
}

})